<template>
    <div class="match-sign-result" ref="printArea">
        <div class="sign-result-card" v-loading="loading">
            <div style="text-align: center;font-size: 30px;margin-bottom: 20px; height: 50px;line-height: 50px;">报名表
            </div>
            <!-- 赛事基本信息 -->
            <table class="info-table">
                <tr>
                    <td class="label">赛事名称：</td>
                    <td colspan="4">{{ signData.MatchName }}</td>
                </tr>
                <tr>
                    <td class="label">赛事时间：</td>
                    <td colspan="2">{{ formatDateTime(signData.MatchStartTime) }} ~ {{
                        formatDateTime(signData.MatchEndTime) }}</td>
                    <td class="label">组别:</td>
                    <td>{{ signData.GroupName }}
                        ({{ signData.Groups[0].IsSuper == 1 ? '超级组' : '普通组' }})
                    </td>
                </tr>
                <tr>
                    <td class="label">参赛单位：</td>
                    <td colspan="4">{{ signData.UnitName }}</td>
                </tr>
                <tr>
                    <td class="label">单位联系人：</td>
                    <td colspan="2">{{ signData.UnitManagerName }}</td>
                    <td class="label">联系电话：</td>
                    <td>{{ signData.UnitManagerPhone }}</td>
                </tr>
            </table>
            <div class="athletes-detail-list" v-if="signData.UnitAthletes.length > 0">
                <h4 style="padding: 10px 0;">参赛运动员信息</h4>
                <table class="info-table">
                    <tr>
                        <td style="width: 50px;text-align: center;">序号</td>
                        <td>项目名称</td>
                        <td style="width: 120px;">项目类型</td>
                        <td style="width: 100px;">性别</td>
                        <td>参赛运动员</td>
                    </tr>
                    <tr v-for="(item, index) in joinProject()">
                        <td style="text-align: center;">
                            {{ index + 1 }}
                        </td>
                        <td>
                            {{ item.ProjectName }}
                        </td>
                        <td>
                            {{ item.ProjectTypeName }}
                        </td>
                        <td>
                            <span v-if="item.GenderRule == 0">男子项目</span>
                            <span v-if="item.GenderRule == 1">女子项目</span>
                            <span v-if="item.GenderRule == 2">男女混合项目</span>
                        </td>
                        <td>{{ item.AthleteNames }}</td>
                    </tr>
                </table>

                <!-- <el-table :data="joinProject()" border size="mini" style="width: 100%; margin-bottom: 20px;">
                    <el-table-column prop="GroupName" label="组别" width="130" align="center">
                        <template v-slot="scope">
                            {{ scope.row.GroupName }}
                            ({{ scope.row.IsSuper == 1 ? '超级组' : '普通组' }})
                        </template>
</el-table-column>
<el-table-column prop="ProjectName" label="项目名称" width="180" align="center"></el-table-column>
<el-table-column prop="ProjectTypeName" label="项目类型" width="110" align="center"></el-table-column>
<el-table-column label="性别" align="center" width="120">
    <template v-slot="scope">
                            <span v-if="scope.row.GenderRule == 0">男子项目</span>
                            <span v-if="scope.row.GenderRule == 1">女子项目</span>
                            <span v-if="scope.row.GenderRule == 2">男女混合项目</span>
                        </template>
</el-table-column>
<el-table-column prop="AthleteNames" label="参赛运动员" width="250"></el-table-column>
</el-table> -->
            </div>


            <div class="athletes-detail-list" v-if="signData.UnitAthletes.length > 0">
                <h4 style="padding: 10px 0;">参赛运动员信息</h4>

                <table class="info-table">
                    <tr>
                        <td class="align-center" style="width: 50px;">序号</td>
                        <td class="align-center">姓名</td>
                        <td class="align-center" style="width: 120px;">身份证号码</td>
                        <td class="align-center" style="width: 80px;">性别</td>
                        <td class="align-center" style="width: 80px;">年龄</td>
                        <td class="align-center">手机号</td>
                        <td class="align-center">年级专业</td>
                        <td class="align-center">证件</td>
                    </tr>
                    <tr v-for="(item, index) in signData.UnitAthletes">
                        <td class="align-center">
                            {{ index + 1 }}
                        </td>
                        <td class="align-center">
                            <!-- <span style="cursor: pointer;">{{ item.UserName }}</span> -->
                           
                            <span>{{ item.UserName }} </span>
                        </td>
                        <td class="align-center">
                            {{ item.IdentityCard }}
                        </td>
                        <td class="align-center">
                            <span v-if="item.Gender == 0">男子</span>
                            <span v-if="item.Gender == 1">女子</span>
                        </td>
                        <td class="align-center">{{ item.Age }}</td>
                        <td class="align-center">{{ item.UserPhone }}</td>
                        <td class="align-center">{{ item.Grade }}</td>
                        <td class="align-center">
                             <el-popover placement="bottom" width="500" trigger="click" v-if="item.IdCardFiles && item.IdCardFiles.length > 0">
                                <img style="width: 100%;" v-if="item.IdCardFiles && item.IdCardFiles.length > 0" 
                                :src="fileRootPath + item.IdCardFiles[0].FilePath" alt="运动员照片" 
                                >
                                <span style="cursor: pointer;" slot="reference">点击查看</span>
                            </el-popover>
                        </td>
                    </tr>
                </table>
                <!-- <el-table :data="signData.UnitAthletes" border size="small">
                    <el-table-column prop="UserName" label="姓名" align="center" width="100"></el-table-column>
                    <el-table-column prop="IdentityCard" label="身份证" align="center" width="160"></el-table-column>
                    <el-table-column prop="Age" label="年龄" align="center" width="110"></el-table-column>
                    <el-table-column prop="Gender" label="性别" align="center" width="120">
                        <template #default="scope">
                            <span>{{ scope.row.Gender === 0 ? '男子' : '女子' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="UserPhone" label="联系电话" align="center" width="140"></el-table-column>
                    <el-table-column prop="Grade" label="年级" align="center" width="80"></el-table-column>

                </el-table> -->
            </div>

            <!-- 随队人员列表 -->
            <div class="staff-list" v-if="signData.UnitTeamLeaders.length > 0">
                <h4 style="padding: 10px 0;">随队人员</h4>

                <table class="info-table">
                    <tr>
                        <td class="align-center" style="width: 50px;">序号</td>
                        <td class="align-center">姓名</td>
                        <td class="align-center" style="width: 120px;">身份证号码</td>
                        <td class="align-center" style="width: 80px;">性别</td>
                        <td class="align-center" style="width: 80px;">年龄</td>
                        <td class="align-center">手机号</td>
                        <td class="align-center">身份</td>
                    </tr>
                    <tr v-for="(item, index) in signData.UnitTeamLeaders">
                        <td class="align-center">
                            {{ index + 1 }}
                        </td>
                        <td class="align-center">
                            {{ item.StaffName }}
                        </td>
                        <td class="align-center">
                            {{ item.IdentityCard }}
                        </td>
                        <td class="align-center">
                            <span v-if="item.Gender == 0">男子</span>
                            <span v-if="item.Gender == 1">女子</span>
                        </td>
                        <td class="align-center">{{ item.Age }}</td>
                        <td class="align-center">{{ item.StaffPhone }}</td>
                        <td class="align-center">{{ item.Post }}</td>
                    </tr>
                </table>



                <!-- <el-table :data="signData.UnitTeamLeaders" border size="small">
                    <el-table-column prop="StaffName" label="姓名" align="center" width="130"></el-table-column>
                    <el-table-column prop="IdentityCard" label="身份证" align="center" width="180"></el-table-column>
                    <el-table-column prop="Age" label="年龄" align="center" width="110"></el-table-column>
                    <el-table-column prop="Gender" label="性别" align="center" width="130">
                        <template #default="scope">
                            <span>{{ scope.row.Gender === 0 ? '男子' : '女子' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Post" label="身份" align="center" width="110"></el-table-column>
                    <el-table-column prop="StaffPhone" label="联系电话" align="center" width="130"></el-table-column>
                </el-table> -->
            </div>
            <div class="team-photo-list" v-if="signData && signData.TeamPhotoFiles">
                <h4 style="padding: 10px 0;">团队照片</h4>
                <el-image v-for="file in signData.TeamPhotoFiles"
                    style="width: 100px; height: 100px;margin-right: 10px;"
                    :src="fileRootPath + file.SaveFolder + '/' + file.FileId + file.FileSuffix"
                    :preview-src-list="[fileRootPath + file.SaveFolder + '/' + file.FileId + file.FileSuffix]">
                </el-image>
            </div>


            <!-- 无数据时显示 -->
            <el-empty v-if="!signData.Groups || signData.Groups.length === 0" description="暂无报名数据">
            </el-empty>
        </div>
    </div>
</template>

<script>
import Url from '@/request-server/request-url';
export default {
    name: 'MatchSignResult',
    data() {
        return {
            fileRootPath: ''
        }
    },
    props: {
        // 报名数据，包含所有信息的对象
        signData: {
            type: Object,
            default: () => ({
                MatchName: '',
                MatchStartTime: '',
                MatchEndTime: '',
                UnitName: '',
                UnitManagerName: '',
                UnitManagerPhone: '',
                Groups: [],
                UnitTeamLeaders: [],
                UnitAthletes: [],
                TeamPhotoFiles: []
            })
        },
        // 是否显示加载中
        loading: {
            type: Boolean,
            default: false
        }
    },
    created() {
        this.fileRootPath = Url.getDownloadBaseUrl() + 'uploadfiles/'
    },
    methods: {
        joinProject() {
            if (!this.signData.Groups || this.signData.Groups.length == 0) return [];

            let pros = [];
            this.signData.Groups.forEach(g => {
                pros = [...pros, ...g.Projects]
            });

            return pros;
        },
        // 打印报名表
        printForm() {
            // 执行打印
            window.print();
        },
        // 如有需要可添加方法
        formatDateTime(dateTimeStr) {
            if (!dateTimeStr) return '';
            // 替换字符串中的'T'为空格
            return dateTimeStr.replace('T', ' ');
        },
    }
}
</script>

<style lang="scss" scoped>
.match-sign-result {
    width: 100%;

    .sign-result-card {
        width: 210mm;
        margin: 0 auto;

        .basic-info-card {
            margin-bottom: 20px;

        }

        .match-title {
            font-size: 20px;
            font-weight: bold;
            color: #303133;
            text-align: center;
            margin-bottom: 15px;
        }

        .basic-info {
            .info-item {
                margin-bottom: 10px;
                font-size: 14px;

                .label {
                    font-weight: bold;
                    margin-right: 5px;
                }
            }
        }

        .card-header {
            font-weight: bold;
            color: #409EFF;
        }

        .group-section {
            margin-bottom: 20px;

            .group-title {
                font-size: 16px;
                font-weight: bold;
                color: #409EFF;
                margin-bottom: 10px;
                border-left: 3px solid #409EFF;
                padding-left: 10px;
            }
        }

        .team-item {
            margin-bottom: 8px;

            .team-name {
                margin-bottom: 5px;
                font-weight: bold;
            }
        }

        .staff-card,
        .athlete-card,
        .group-card {
            margin-bottom: 20px;
        }
    }
}

.info-table {
    width: 98%;
    border-collapse: collapse;
    margin-bottom: 20px;
    table-layout: fixed;
    /* 添加固定表格布局 */
}

.info-table td {
    padding: 8px;
    border: 1px solid #DCDFE6;
    line-height: 24px;
}

.info-table .label {
    background-color: #F5F7FA;
    font-weight: bold;
    width: 120px;
}

/* 确保第三列标签的宽度与第一列一致 */
.info-table td:nth-child(3).label {
    width: 120px;
}

/* 非打印时隐藏打印相关元素 */
@media print {
    .print-hide {
        display: none !important;
    }

    .match-sign-result {
        width: 100%;
        max-width: 210mm;
        /* A4 宽度 */
        margin: 0 auto;
    }

    .sign-result-card {
        width: 100%;
        padding: 0;
        box-sizing: border-box;
    }

    /* 加强选择器特异性，以覆盖 Element UI 样式 */
    .el-table,
    .el-table__header,
    .el-table__body {
        width: 100% !important;
        font-size: 12px;
    }

    /* 直接针对所有表格单元格，无论是否在 Element UI 表格中 */
    table td,
    table th {
        border: 1px solid #000 !important;
    }

    /* 特别处理 Element UI 表格的单元格 */
    .el-table th.is-leaf,
    .el-table td {
        border: 1px solid #000 !important;
    }

    /* 覆盖 Element UI 内部组件的边框 */
    .el-table__fixed::before,
    .el-table__fixed-right::before,
    .el-table::before,
    .el-table::after {
        background-color: #000 !important;
        height: 1px !important;
    }

    /* 确保表格单元格内容换行 */
    .el-table .cell {
        padding-left: 5px;
        padding-right: 5px;
        word-break: break-all;
    }

    /* 基本信息表格加深边框 */
    .info-table,
    .info-table td,
    .info-table th {
        border: 1px solid #000 !important;
    }
}

.align-center {
    text-align: center;
}

/* 打印时应用的样式 */
@media screen {
    .print-hide {
        display: block;
    }
}
</style>